import { GroupIcon } from 'NewVersion/icons/GroupIcon'
import { UserIcon } from 'NewVersion/icons/UserIcon'
import 'NewVersion/styles/RoleSelector.scss'
import { useTranslation } from 'react-i18next'
import { ENS_TYPES_OBJ } from 'utils/entityUtils'

/**
 * RoleSelector - Component for selecting between Artist and Representant roles
 *
 * @param {function} onRoleSelected - Callback when a role is selected (receives 'artista' or 'representant')
 */
export const RoleSelector = ({ onRoleSelected }) => {
  const { t } = useTranslation()

  return (
    <div className="role-selector">
      <p className="role-selector__title">{t('role_selector_title')}</p>
      <p className="role-selector__description">{t('role_selector_description')}</p>

      <div className="role-selector__options">
        <button
          className="role-selector__option"
          onClick={() => onRoleSelected(ENS_TYPES_OBJ.artista.text)}
          data-test="btnSelectRoleArtist"
        >
          <div className="role-selector__option-icon">
            <UserIcon />
          </div>
          <div className="role-selector__option-content">
            <p className="role-selector__option-title">{t('soc_artista')}</p>
            <p className="role-selector__option-desc">{t('soc_artista_desc')}</p>
          </div>
        </button>

        <button
          className="role-selector__option"
          onClick={() => onRoleSelected(ENS_TYPES_OBJ.representant.text)}
          data-test="btnSelectRoleRepresentant"
        >
          <div className="role-selector__option-icon">
            <GroupIcon />
          </div>
          <div className="role-selector__option-content">
            <p className="role-selector__option-title">{t('soc_representant')}</p>
            <p className="role-selector__option-desc">{t('soc_representant_desc')}</p>
          </div>
        </button>
      </div>
    </div>
  )
}

export default RoleSelector
